import {Component} from "@angular/core";

@Component({
    selector: "fui-podium",
    styleUrls: ["./podium.component.scss"],
    templateUrl: "./podium.component.html"
})
export class FUIPodiumComponent {

}
